<template>
  <q-layout view="hHh lpR fFf">
    <div id="configuracao">
      <div class="q-pa-md" style="min-height: 100vh; display: flex; align-items: center; justify-content: center;">
        <div style="max-width: 480px; width: 100%;">
          <q-card flat class="text-center q-pa-lg">
            <q-card-section>
              <img src="@/assets/douranovo.png" alt="DouraSoft Logo" width="150" />
            </q-card-section>

            <q-card-section>
              <q-spinner-dots color="blue-7" size="3em" />
            </q-card-section>

            <q-card-section class="q-pt-none">
              <p class="text-h6 text-grey-8 q-mb-sm">
                Estamos preparando tudo para você
              </p>
              <p class="text-body1 text-grey-6">
                {{ statusMessage }}
              </p>
              <q-linear-progress
                indeterminate
                color="blue-7"
                class="q-mt-lg"
                rounded
                size="6px"
              />
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </q-layout>
</template>

<script>
import axios from "@/axios-auth";
import { Notify, createMetaMixin } from "quasar";
export default {
  name: "config",
  mixins: [createMetaMixin({ title: "DSB | Configuração" })],
  data() {
    return {
      statusMessage: "Aguarde enquanto configuramos seu ambiente...",
      pollingInterval: null
    };
  },
  methods: {
    config() {
      axios
        .post(
          "/users/config",
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage["token" + localStorage["empresa_atual"]]
            }
          }
        )
        .then(res => {
          if (res.data.message) {
            this.statusMessage = res.data.message;
          }
          if (res.data.success) {
            this.stopPolling();
            Notify.create({
              message: res.data.message,
              color: "green",
              position: "top-right"
            });
            // vue-router 4 navigations are always asynchronous. Vue Router 3 committed this
            // push synchronously (the target's guard is synchronous), so the reload below
            // happened on /tour. Now the reload would fire before the URL changes and
            // reload the current page instead — on /configuracao that restarts the polling
            // that got here, in a loop. Reload once the navigation has settled, as before.
            this.$router.push("/tour").finally(() => this.$router.go(0));
          }
        })
        .catch(() => {
          this.statusMessage = "Tentando conectar ao servidor...";
        });
    },
    startPolling() {
      this.config();
      this.pollingInterval = setInterval(() => {
        this.config();
      }, 5000);
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    }
  },
  computed: {
    route() {
      return this.$route.path;
    },
    token() {
      return this.$store.getters.token;
    }
  },
  mounted() {
    this.startPolling();
  },
  beforeUnmount() {
    this.stopPolling();
  }
};
</script>

